import React from "react";
import { Col, Row } from "antd";
import { HiOutlineMenu } from "react-icons/hi";
import Button from "../Button";
import { isMobile } from "../../utils";
import { LayoutHeader } from "./styles";
import { useAuth } from "../../contexts/AuthContext";

interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = () => {
  const { setShowDrawer } = useAuth();

  const theme = {
    isMobile: isMobile(),
  };

  return (
    <>
      <LayoutHeader theme={theme}>
        {isMobile() && (
          <Row align="middle" gutter={[16, 16]}>
            <Col>
              <Button
                size="large"
                type="primary"
                className="menu-button"
                icon={<HiOutlineMenu />}
                onClick={() => setShowDrawer(true)}
              />
            </Col>
          </Row>
        )}
      </LayoutHeader>
    </>
  );
};

export default Header;
